import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { actualizarVersionIndicadores, infoIndicadoresCategoria } from "../../actions/configFormularioAction";
import { esborrarErrorAction, uiActualizarTextosStateAction, uiActualizarIndicadoresStateAction, esborrarOkAction } from "../../actions/ui";
import { ComponenteFormularioIndicadores } from "./ComponenteFormularioIndicadores";

const IconChevDown = ({ open }) => (
  <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}
    style={{ transition:'transform 0.2s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)', flexShrink:0 }}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"/>
  </svg>
);

const IconUpload = () => (
  <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"/>
  </svg>
);

export const FormularioIndicadoresAdmin = () => {
  const [t]         = useTranslation("generic");
  const dispatch    = useDispatch();
  const navegacio   = useNavigate();
  const [cat, setCat]             = useState(null);
  const [primerCop, setPrimerCop] = useState(true);

  const { auth, configFormulario, ui } = useSelector((state) => state);
  const { msgOk } = ui;
  const { infoFormularioIndicadoresCategoria, infoFormularioTextCategoria } = configFormulario;

  const handleObrirCat = (e, cerrar, id) => {
    dispatch(esborrarOkAction());
    e.preventDefault();
    if (id == cat && cerrar) { setCat(null); dispatch(uiActualizarTextosStateAction(1)); }
    else { if (cerrar) dispatch(uiActualizarTextosStateAction(1)); setCat(id); }
    dispatch(esborrarErrorAction());
  };

  const manejarSubirVersion = () => {
    dispatch(actualizarVersionIndicadores(auth.tokenJwt, infoFormularioIndicadoresCategoria?.nuevaVersion?.version));
    navegacio("/login");
  };

  useEffect(() => {
    if (primerCop && configFormulario.infoFormularioIndicadoresCategoria == null) {
      dispatch(infoIndicadoresCategoria(auth.tokenJwt));
      dispatch(uiActualizarTextosStateAction(1));
      setPrimerCop(false);
    }
  }, [configFormulario, cat]);

  const [disabled] = useState({ cat1:false,cat2:false,cat3:false,cat4:false,cat5:false,cat6:false,cat7:false,cat8:false,cat9:false,cat10:false });

  useEffect(() => {
    if (ui.msgError !== null) setTimeout(() => dispatch(esborrarErrorAction()), 10000);
    if (ui.msgOk    !== null) { setTimeout(() => dispatch(esborrarOkAction()), 10000); setCat(null); }
  }, [ui]);

  const renderAccordionItem = (catIndex, titulo) => {
    const isOpen = cat == catIndex;
    return (
      <div key={catIndex} className="fa-accordion" style={{ borderColor: isOpen ? '#111827' : '#e5e7eb' }}>

        <button
          className="fa-accordion-header"
          onClick={(e) => handleObrirCat(e, true, catIndex)}
          disabled={disabled[`cat${catIndex}`]}
        >
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <span className="fa-cat-badge" style={{ background: isOpen ? '#111827' : '#f3f4f6', color: isOpen ? '#fff' : '#6b7280' }}>
              {catIndex === 10 ? '★' : catIndex}
            </span>
            <span className="fa-accordion-title" style={{ color: isOpen ? '#111827' : '#374151' }}>
              {titulo}
            </span>
          </div>
          <IconChevDown open={isOpen} />
        </button>

        {isOpen && (
          <div style={{ borderTop: '1px solid #f3f4f6' }}>
            {/* Sub-tabs Pregunta / Programa */}
            <div className="fa-subtabs" style={{ padding: '12px 20px', background: '#f9fafb', borderBottom: '1px solid #f3f4f6', marginBottom: 0 }}>
              {['Pregunta', 'Programa'].map((label, i) => {
                const stateVal = i + 1;
                const active   = (ui.indicadoresState || 1) === stateVal;
                return (
                  <button
                    key={label}
                    className={`fa-subtab${active ? ' active' : ''}`}
                    onClick={(e) => { dispatch(uiActualizarIndicadoresStateAction(stateVal)); handleObrirCat(e, false, catIndex); }}
                  >{label}</button>
                );
              })}
            </div>
            <ComponenteFormularioIndicadores key={`form-category-${catIndex}`} catIndex={catIndex} />
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      {/* ── Cabecera ─────────────────────────────────────────────────── */}
      <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:16, marginBottom:16, flexWrap:'wrap' }}>
        <div>
          <p className="ca-label-super">Administración</p>
          <h2 className="ca-h2">Modificar Indicadores</h2>
          <p className="ca-subtext">Ajusta los pesos de cada indicador del formulario</p>
        </div>
        <button onClick={manejarSubirVersion} className="u-btn-primary">
          <IconUpload />
          Pujar Versió &nbsp;
          <span style={{ fontSize:11, fontWeight:400, opacity:0.8 }}>
            [{infoFormularioIndicadoresCategoria?.nuevaVersion?.Data_version}]
          </span>
        </button>
      </div>

      {/* ── Alertas ───────────────────────────────────────────────────── */}
      {ui.msgError && <div className="ms-alert-error">{ui.msgError}</div>}
      {msgOk       && <div className="ms-alert-success">{msgOk}</div>}

      {/* ── Acordeones ───────────────────────────────────────────────── */}
      {infoFormularioIndicadoresCategoria != null ? (
        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          {renderAccordionItem(10, 'Peso General de las Categorías')}
          {Array.from({ length: 9 }, (_, i) => i + 1).map((catIndex) => {
            const titulo = infoFormularioTextCategoria?.[`Categoria${catIndex}`]?.[`Cat${catIndex}_Titol`] || `Categoría ${catIndex}`;
            return renderAccordionItem(catIndex, titulo);
          })}
        </div>
      ) : (
        <div className="u-empty-state">Cargando indicadores...</div>
      )}
    </div>
  );
};